<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('recovery.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content-top">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 1}"
                     @click="changeTimeType(1, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}
                </div>
                <div class="time-item" :class="{'time-active': activeTime === 2}"
                     @click="changeTimeType(2, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}
                </div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{ time }}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
            </div>
            <div class="avg-score-box">
                <img class="score-bg" :src="require(`@/assets/theme/${theme}/status/06sleep/07scoreBg.png`)">
                <div class="avg-score-title">{{ $t('recovery.average') }}</div>
                <div class="avg-score-value">{{ recoveryInfo.recoveryRangeMath.recoveryScore ? Math.ceil(recoveryInfo.recoveryRangeMath.recoveryScore) : '--' }}<span class="avg-unit">%</span></div>
                <div class="compare-box" v-if="!noData && recoveryInfo.recoveryRangeMath && recoveryInfo.recoveryRangeMath.recoveryScoreLast != null">
                    <img :src="recoveryInfo.recoveryRangeMath.recoveryScore >= recoveryInfo.recoveryRangeMath.recoveryScoreLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                    {{ Math.abs(Math.ceil(recoveryInfo.recoveryRangeMath.recoveryScore) - Math.ceil(recoveryInfo.recoveryRangeMath.recoveryScoreLast)) }}%
                </div>
                <div class="compare-text">{{ $t('recovery.vsLastWeek') }}</div>
            </div>
        </div>
        <div>
            <div class="suggest-title">{{ $t('recovery.trends') }}</div>
            <div class="trends-chart-box">
                <div class="trends-chart-out">
                    <div id="trends-chart"></div>
                    <div id="y-axis-lines">
                        <div style="height: 25%; background-color: var(--chart-color-1);"></div>
                        <div style="height: 25%; background-color: var(--chart-color-5);"></div>
                        <div style="height: 50%; background-color: var(--chart-color-3);"></div>
                    </div>
                </div>

                <div class="score-item">
                    <div class="score-img-box">
                        <img class="score-img" src="@/assets/theme/light/status/06sleep/09scoreBg.svg">
                        <div v-if="sleepDays" class="score-ratio score-color-1"
                             :style="{'width': scoreRatioArr[0] / sleepDays * 140 + 'px'}"></div>
                        <div class="score-color-bar score-color-1"></div>
                    </div>
                    <div class="score-text">{{ scoreRatioArr[0] }}{{ $t('recovery.days') }}</div>
                    <div class="score-num-level">{{ $t('recovery.scoreGt75') }}</div>
                </div>
                <div class="score-item">
                    <div class="score-img-box">
                        <img class="score-img" src="@/assets/theme/light/status/06sleep/09scoreBg.svg">
                        <div v-if="sleepDays" class="score-ratio score-color-2"
                             :style="{'width': scoreRatioArr[1] / sleepDays * 140 + 'px'}"></div>
                        <div class="score-color-bar score-color-2"></div>
                    </div>
                    <div class="score-text">{{ scoreRatioArr[1] }}{{ $t('recovery.days') }}</div>
                    <div class="score-num-level">{{ $t('recovery.score50to75') }}</div>
                </div>
                <div class="score-item">
                    <div class="score-img-box">
                        <img class="score-img" src="@/assets/theme/light/status/06sleep/09scoreBg.svg">
                        <div v-if="sleepDays" class="score-ratio score-color-3"
                             :style="{'width': scoreRatioArr[2] / sleepDays * 140 + 'px'}"></div>
                        <div class="score-color-bar score-color-3"></div>
                    </div>
                    <div class="score-text">{{ scoreRatioArr[2] }}{{ $t('recovery.days') }}</div>
                    <div class="score-num-level">{{ $t('recovery.scoreLt50') }}</div>
                </div>
                <div class="score-suggest">
                    {{ $t('recovery.suggestText') }}
                </div>
            </div>
            <div class="suggest-title">{{ $t('recovery.hrv') }}
                <img class="info-icon"
                     :src="require(`@/assets/theme/${theme}/status/06sleep/01info.svg`)">
            </div>
            <div class="score-chart-box">
                <div class="avg-duration-title">{{ $t('recovery.avgHrv') }}</div>
                <div class="vs-line">
                    <div class="avg-efficiency-line">
                        <div class="avg-efficiency-value">{{ noData ? '--' : (recoveryInfo.recoveryRangeMath && recoveryInfo.recoveryRangeMath.hrvAvg != null ? Math.ceil(recoveryInfo.recoveryRangeMath.hrvAvg) : '--') }}</div>
                        <div class="avg-efficiency-unit">ms</div>
                        <div class="avg-efficiency-compare" v-if="!noData && recoveryInfo.recoveryRangeMath && recoveryInfo.recoveryRangeMath.hrDeepAvgLast != null">
                            <img :src="recoveryInfo.recoveryRangeMath.hrvAvg >= recoveryInfo.recoveryRangeMath.hrvAvgLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                            <span class="avg-efficiency-compare-value">{{ Math.abs(recoveryInfo.recoveryRangeMath.hrvAvg - recoveryInfo.recoveryRangeMath.hrvAvgLast).toFixed(1) }}</span>
                        </div>
                    </div>
                    <div class="vs-text">{{ $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle') }}</div>
                </div>
                <div class="hr-chart" id="hrv-chart"></div>
            </div>
            <div class="suggest-title">{{ $t('recovery.restingHr') }}
                <img class="info-icon"
                     :src="require(`@/assets/theme/${theme}/status/06sleep/01info.svg`)">
            </div>
            <div class="score-chart-box">
                <div class="avg-duration-title">{{ $t('recovery.avgRestingHr') }}</div>
                <div class="vs-line">
                    <div class="avg-efficiency-line">
                        <div class="avg-efficiency-value">{{ noData ? '--' : (recoveryInfo.recoveryRangeMath && recoveryInfo.recoveryRangeMath.hrDeepAvg != null ? Math.ceil(recoveryInfo.recoveryRangeMath.hrDeepAvg) : '--') }}</div>
                        <div class="avg-efficiency-unit">bpm</div>
                        <div class="avg-efficiency-compare" v-if="!noData && recoveryInfo.recoveryRangeMath && recoveryInfo.recoveryRangeMath.hrDeepAvgLast != null">
                            <img :src="recoveryInfo.recoveryRangeMath.hrDeepAvg >= recoveryInfo.recoveryRangeMath.hrDeepAvgLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                            <span class="avg-efficiency-compare-value">{{ Math.abs(recoveryInfo.recoveryRangeMath.hrDeepAvg - recoveryInfo.recoveryRangeMath.hrDeepAvgLast).toFixed(1) }}</span>
                        </div>
                    </div>
                    <div class="vs-text">{{ $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle') }}</div>
                </div>
                <div class="hr-chart" id="hr-chart"></div>
            </div>
            <div class="suggest-title">{{ $t('recovery.respiratoryRate') }}
                <img class="info-icon"
                     :src="require(`@/assets/theme/${theme}/status/06sleep/01info.svg`)">
            </div>
            <div class="score-chart-box">
                <div class="avg-duration-title">{{ $t('recovery.avgRespiratoryRate') }}</div>
                <div class="vs-line">
                    <div class="avg-efficiency-line">
                        <div class="avg-efficiency-value">{{ noData ? '--' : (recoveryInfo.recoveryRangeMath && recoveryInfo.recoveryRangeMath.respRateDeepAvg != null ? Math.ceil(recoveryInfo.recoveryRangeMath.respRateDeepAvg) : '--') }}</div>
                        <div class="avg-efficiency-unit"></div>
                        <div class="avg-efficiency-compare" v-if="!noData && recoveryInfo.recoveryRangeMath && recoveryInfo.recoveryRangeMath.respRateDeepAvgLast != null">
                            <img :src="recoveryInfo.recoveryRangeMath.respRateDeepAvg >= recoveryInfo.recoveryRangeMath.respRateDeepAvgLast ? require('@/assets/theme/light/status/06sleep/08up.svg') : require('@/assets/theme/light/status/06sleep/08down.svg')">
                            <span class="avg-efficiency-compare-value">{{ Math.abs(recoveryInfo.recoveryRangeMath.respRateDeepAvg - recoveryInfo.recoveryRangeMath.respRateDeepAvgLast).toFixed(1) }}</span>
                        </div>
                    </div>
                    <div class="vs-text">{{ $t(activeTime === 2 ? 'sleep.vsLastMonthTitle' : 'sleep.vsLastWeekTitle') }}</div>
                </div>
                <div class="hr-chart" id="resp-chart"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {getQueryVariable, getSkin} from '@/utils/comment'
import {
    getNWeekFirstDay,
    getNWeekLastDay,
    getMonthStartDay,
    getMonthEndDay,
    GetDateStr,
    changeMonthDate,
    getDateWeek, getDateDay
} from "../../utils/dateUtils";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'recovery',
    data() {
        return {
            ratio: 1,
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            activeTime: 1,
            time: '',
            startDate: '',
            endDate: '',
            tNum: 0,
            wNum: 0,
            mNum: 0,
            showLeftOpacity: 0,
            showRightOpacity: 1,
            trendsChart: null,
            sleepDays: 0,
            scoreRatioArr: [0, 0, 0],
            hrvChart: null,
            hrChart: null,
            respChart: null,
            noData: false,
            recoveryInfo: {}
        }
    },
    watch: {
        activeTime: {
            handler(newVal) {
                if (newVal === 0) {
                    if (this.trendsChart) {
                        this.trendsChart.dispose();
                        this.trendsChart = null;
                    }
                }
            }
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.changeTimeType(1, this.$t('dailyActive.time0'))
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        checkOpacity() {
            if (this.activeTime == 0 && this.tNum <= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 1 && this.wNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 2 && this.mNum >= 0) {
                this.showRightOpacity = 1
            } else {
                this.showRightOpacity = 0
            }
            if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 2 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else {
                this.showLeftOpacity = 0
            }
        },
        timeLeft() {
            if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                this.tNum++;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                this.wNum--;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.startDate > '2020-01-01') {
                this.mNum--;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            console.log(this.time)
            this.getData();
        },
        timeRight() {
            if (this.activeTime == 0 && this.tNum > 0) {
                this.tNum--;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.wNum < 0) {
                this.wNum++;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.mNum < 0) {
                this.mNum++;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            console.log(this.time)
            this.getData();
        },
        changeTimeType(num, unit) {
            this.activeTime = num;
            if (this.activeTime == 1) {
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 2) {
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            if (this.activeTime == 0) {
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            }
            this.getData();
        },
        getData() {
            this.checkOpacity();
            this.getRecoveryByRange();
        },
        getRecoveryByRange() {
            this.$api.status.getRecoveryByRange({
                startDate: this.startDate,
                endDate: this.endDate,
                type: this.activeTime == 1 ? 'week' : 'month'
            }).then(res => {
                this.recoveryInfo = res.info || {}
                if (res.info && res.info.recoveryRangeMath && res.info.recoveryRangeMath.recoveryScore > 0) {
                    this.noData = false
                } else {
                    this.noData = true
                }
                // 根据时间范围生成 xData
                let startTs = new Date(this.startDate).getTime();
                let endTs = new Date(this.endDate).getTime();
                let xData = [];
                for (let ts = startTs; ts <= endTs; ts += 86400000) {
                    let dateStr = new Date(ts).toISOString().slice(0, 10);
                    let week = getDateWeek(dateStr);
                    let weekStr = this.$t('sleep.week' + week);
                    xData.push(weekStr + '\n' + getDateDay(dateStr));
                }
                // recoveryScoreList 是纯数字数组
                let scoreData = res.info.recoveryScoreList || [];
                this.scoreRatioArr = [0, 0, 0]
                for (let i = 0; i < scoreData.length; i++) {
                    let val = scoreData[i];
                    if (val < 50 && val > 0) {
                        this.scoreRatioArr[2]++
                    } else if (val <= 75 && val > 0) {
                        this.scoreRatioArr[1]++
                    } else if (val > 75) {
                        this.scoreRatioArr[0]++
                    }
                }
                this.sleepDays = scoreData.length;
                this.$nextTick(function () {
                    this.drawTrendsChart(xData, scoreData);
                    this.drawHrvChart(xData, res.info.hrvAvgList || []);
                    this.drawHrChart(xData, res.info.hrDeepAvgList || []);
                    this.drawRespChart(xData, res.info.respRateDeepAvgList || []);
                })
            })
        },
        getItemColor(value) {
            if (value < 50) return getSkin('--chart-color-4');
            if (value < 75) return getSkin('--chart-color-54');
            return getSkin('--chart-color-2');
        },
        getTopColor(value) {
            if (value < 50) return getSkin('--chart-color-3');
            if (value < 75) return getSkin('--chart-color-5');
            return getSkin('--chart-color-1');
        },
        drawTrendsChart(xData, yData) {
            let _this = this;
            if (this.trendsChart) {
                this.trendsChart.dispose();
            }
            this.trendsChart = this.$echarts.init(document.getElementById("trends-chart"));
            if (!this.noData) {
                const maxVal = Math.max(...yData);
                const minVal = Math.min(...yData);
                this.trendsChart.setOption({
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: {
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data + 2 : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-2') + '">' + item.axisValue + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-2') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> % </div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            interval: this.activeTime === 2 ? 6 : 0,
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        min: 0,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        interval: 25,
                        axisLabel: {
                            fontSize: 11,
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                            rich: {
                                color50: {
                                    color: getSkin('--chart-color-3')
                                },
                                color75: {
                                    color: getSkin('--chart-color-5')
                                },
                                color100: {
                                    color: getSkin('--chart-color-1')
                                }
                            },
                            formatter: function (value) {
                                if (Math.abs(value - 50) < 0.1) {
                                    return '{color50|50%}';
                                }
                                if (Math.abs(value - 75) < 0.1) {
                                    return '{color75|75%}';
                                }
                                if (Math.abs(value - 100) < 0.1) {
                                    return '{color100|100%}';
                                }
                                return '';
                            }
                        }
                    },
                    series: [
                        {
                            data: yData.map(val => val - 2),
                            type: 'bar',
                            stack: 'total',
                            barWidth: '50%',
                            lineStyle: {
                                color: getSkin('--text-color-3'),
                                width: 2 * this.ratio
                            },
                            itemStyle: {
                                color: function (params) {
                                    return _this.getItemColor(params.data);
                                },
                            },
                            label: {
                                show: true,
                                position: 'top',
                                color: getSkin('--text-color-1'),
                                fontSize: 11 * this.ratio,
                                fontWeight: 'bold',
                                formatter: (params) => {
                                    const realVal = yData[params.dataIndex];
                                    if (realVal == null || realVal == 0) return '';
                                    if (_this.activeTime == 2) {
                                        if (realVal === maxVal || realVal === minVal) {
                                            return realVal + '%';
                                        }
                                        return '';
                                    } else {
                                        return realVal + '%';
                                    }
                                }
                            },
                        },
                        {
                            type: 'bar',
                            barWidth: '40%',
                            stack: 'total',
                            itemStyle: {
                                color: function (params) {
                                    const realValue = yData[params.dataIndex];
                                    return _this.getTopColor(realValue);
                                }
                            },
                            data: yData.map(val => val == 0 ? null : 2)
                        }
                    ]
                }, true)
            } else {
                this.trendsChart.setOption({
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            formatter: '{value}%'
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }
        },
        drawHrvChart(xData, yData) {
            let _this = this;
            if (this.hrvChart) {
                this.hrvChart.dispose();
            }
            this.hrvChart = this.$echarts.init(document.getElementById("hrv-chart"));
            if (!this.noData) {
                this.hrvChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        top: 12 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-2'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    dataZoom: {
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-2') + '">' + item.axisValue + '</div>'
                            html += '<div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-2') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> ms </div></div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        boundaryGap: [0, '10%'],
                        interval: 25,
                        max: 100,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                        }
                    },
                    series: [
                        {
                            data: yData,
                            type: 'line',
                            color: getSkin('--chart-color-8'),
                            smooth: true,
                            showSymbol: false,
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: 'rgba(34, 172, 251, 0)',
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(34, 172, 251, 0.70)',
                                    },
                                ]),
                            }
                        }
                    ]
                }, true)
            } else {
                this.hrvChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }
        },
        drawHrChart(xData, yData) {
            let _this = this;
            if (this.hrChart) {
                this.hrChart.dispose();
            }
            this.hrChart = this.$echarts.init(document.getElementById("hr-chart"));
            if (!this.noData) {
                this.hrChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        top: 12 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-2'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    dataZoom: {
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-2') + '">' + item.axisValue + '</div>'
                            html += '<div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-2') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> bpm </div></div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        splitNumber: 4,
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                        }
                    },
                    series: [
                        {
                            data: yData,
                            type: 'line',
                            color: getSkin('--chart-color-3'),
                            smooth: true,
                            showSymbol: false,
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: 'rgba(241, 37, 65, 0)',
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(241, 37, 65, 0.7)',
                                    },
                                ]),
                            }
                        }
                    ]
                }, true)
            } else {
                this.hrChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }
        },
        drawRespChart(xData, yData) {
            let _this = this;
            if (this.respChart) {
                this.respChart.dispose();
            }
            this.respChart = this.$echarts.init(document.getElementById("resp-chart"));
            if (!this.noData) {
                this.respChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    legend: {
                        top: 12 * this.ratio,
                        itemWidth: 15 * this.ratio,
                        itemHeight: 8 * this.ratio,
                        textStyle: {
                            color: getSkin('--text-color-2'),
                            fontSize: 11 * this.ratio,
                            fontFamily: "'D-D','SF'",
                        },
                        itemGap: 32 * this.ratio,
                    },
                    dataZoom: {
                        type: 'inside'
                    },
                    emphasis: {
                        disabled: true,
                    },
                    tooltip: {
                        borderColor: 'transparent',
                        backgroundColor: getSkin('--bg-color-3'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? item.data : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-2') + '">' + item.axisValue + '</div>'
                            html += '<div><div style="display: inline-block;font-size:13px;color: ' + getSkin('--text-color-2') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> </div></div>';
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3'),
                            }
                        },
                        splitNumber: 4,
                        axisLabel: {
                            fontSize: 11,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                        }
                    },
                    series: [
                        {
                            data: yData,
                            type: 'line',
                            color: getSkin('--chart-color-1'),
                            smooth: true,
                            showSymbol: false,
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: getSkin('--chart-color-1p1'),
                                    },
                                    {
                                        offset: 1,
                                        color: getSkin('--chart-color-1p7'),
                                    },
                                ]),
                            }
                        }
                    ]
                }, true)
            } else {
                this.respChart.setOption({
                    grid: {
                        top: 16 * this.ratio,
                        bottom: 42 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 70 * this.ratio,
                        textStyle: {
                            fontFamily: 'Manteka',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                        },
                        axisTick: {
                            show: false
                        },
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        max: 100,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                        }
                    ]
                }, true)
            }
        }
    },
    unmounted() {
        if (this.trendsChart) {
            this.trendsChart.dispose();
        }
        if (this.hrvChart) {
            this.hrvChart.dispose();
        }
        if (this.hrChart) {
            this.hrChart.dispose();
        }
    }
}
</script>

<style scoped>

.suggest-title {
    color: var(--text-color-2);
    font-size: 15px;
    margin-left: 15px;
    margin-top: 16px;
    letter-spacing: 2px;
    display: flex;
}

.arr-opacity {
    opacity: 0.2;
}

.content-top {
    width: 100%;
    margin-top: 88px;
}

.trends-chart-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 10px 10px 10px 10px;
    margin: 13px auto 20px;
}

#trends-chart {
    width: 345px;
    height: 190px;
}

.avg-score-box {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    position: relative;
    text-align: center;
}

.score-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 200px;
    height: 200px;
}

.avg-score-title {
    position: absolute;
    top: 60px;
    width: 200px;
    font-size: 13px;
    color: var(--text-color-2);
    letter-spacing: 2px;
}

.avg-score-value {
    position: absolute;
    top: 70px;
    font-size: 44px;
    color: var(--text-color-1);
    width: 200px;
}

.compare-box {
    font-size: 13px;
    color: var(--chart-color-1);
    width: 200px;
    position: absolute;
    top: 120px;
}

.compare-text {
    font-size: 11px;
    color: var(--text-color-2);
    position: absolute;
    top: 140px;
    width: 200px;
}

.score-item {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
}

.score-img-box {
    position: relative;
    width: 140px;
}

.score-img {
    position: absolute;
    width: 140px;
    height: 14px;
}

.score-color-bar {
    width: 2px;
    height: 14px;
    border-radius: 3px;
    position: absolute;
    right: 0;
}

.score-color-1 {
    background: var(--chart-color-1);
}

.score-color-2 {
    background: var(--chart-color-5);
}

.score-color-3 {
    background: var(--chart-color-3);
}

.score-ratio {
    height: 14px;
    border-radius: 3px;
    position: absolute;
    left: 0;
}

.score-text {
    font-size: 13px;
    color: var(--text-color-1);
    margin: 0 0 0 9px;
    width: 57px;
}

.score-num-level {
    font-size: 13px;
    color: var(--text-color-2);
    width: 50px;
    float: left;
}

.score-suggest {
    font-size: 13px;
    color: var(--text-color-2);
    line-height: 18px;
    margin: 0 16px;
    padding-bottom: 16px;
}

.hr-chart {
    width: 345px;
    height: 196px;
}

.avg-unit {
    font-size: 16px;
    margin-left: 4px;
}

.chart-title {
    display: flex;
    justify-content: space-between;
    margin: 12px;
    padding-top: 16px;
}

.chart-title-left {
    display: flex;
}

.chart-title-text {
    font-size: 13px;
    margin-left: 8px;
}

.trends-chart-out {
    width: 345px;
    height: 190px;
    position: relative;
}

#y-axis-lines {
    position: absolute;
    left: 41px;
    top: 35px;
    width: 2px;
    bottom: 37px;
}

.vs-line {
    display: flex;
    justify-content: space-between;
}

.vs-text {
    font-size: 11px;
    color: var(--text-color-3);
    margin-right: 16px;
}

.avg-duration-title {
    font-size: 13px;
    color: var(--text-color-1);
    padding-top: 16px;
    margin-left: 16px;
    margin-bottom: 4px;
}

.avg-efficiency-value {
    font-size: 20px;
    color: var(--text-color-1);
    margin-left: 16px;
}

.avg-efficiency-unit {
    font-size: 13px;
    color: var(--text-color-1);
    margin-left: 4px;
    margin-right: 8px;
}

.avg-efficiency-compare {
    background: var(--chart-color-1p1);
    border-radius: 3px 3px 3px 3px;
    color: var(--chart-color-1);
    font-size: 13px;
    padding: 2px 4px;
}

.avg-efficiency-line {
    display: flex;
    align-items: center;
}

.avg-efficiency-compare-value {
    margin-left: 5px;
}

.score-chart-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 10px 10px 10px 10px;
    margin: 13px auto 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/status/26recovery.vue